(function($){
  $(document).on('nfFormReady', function(){
    if ($('.form__wrapper').length && $('.form__wrapper').data('title') && $('.form__wrapper').data('permalink')){
      $('#nf-field-32').val($('.form__wrapper').data('permalink'));
      $('#nf-field-19').val($('.form__wrapper').data('title'));
    }
  });
})(jQuery);
